import { Suspense, use } from 'react';
import { browser } from 'react-dom';
import './EditLink.scss';
import { getCookie } from '@/utils/cookies';
import { useAppData } from '@/contexts';

function EditLinkContent() {
  // The marker cookie is unknown during SSR: suspend on the server (fallback
  // renders instead), resolve once hydrated on the client.
  use(browser());

  const data = useAppData();
  const isEditor = getCookie('lemon_editor') === '1';
  if (!isEditor) return null;

  const postId = data?.post?.id;
  const boAdminUrl = data?.site?.bo_admin_url;
  if (!postId || !boAdminUrl) return null;

  const editUrl = `${boAdminUrl.replace(/\/$/, '')}/post.php?post=${postId}&action=edit`;

  return (
    <a
      className="edit-link"
      href={editUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      Modifier
    </a>
  );
}

export function EditLink() {
  return (
    <Suspense fallback={null}>
      <EditLinkContent />
    </Suspense>
  );
}

export default EditLink;
